<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import { RouterView } from 'vue-router';

const Toaster = defineAsyncComponent(() =>
  import('./components/ui/sonner').then(({ Toaster }) => Toaster),
);
</script>

<template>
  <RouterView v-slot="{ Component }">
    <Component :is="Component" />
  </RouterView>
  <ClientOnly>
    <Toaster />
  </ClientOnly>
</template>
